module.exports = __webpack_public_path__ + "img/it_3.ebaf67e4.jpg";